import React, { useState } from 'react';
import { SimpleGrid, Stack, MultiSelect, Space, Text, Flex, Container } from '@mantine/core';
import { useLoaderData } from 'react-router-dom';
import Input from '../../Components/Input';
import { IconComponents, IconUser } from '@tabler/icons';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';
import { Client } from '../../../backend/models/client';
import ClientCard from './Card';

const ClientList = () => {
  const { technologies, clients, persons } = useLoaderData() as AggregatedDataLoaderResult;

  const [filteredTechnologies, setFilteredTechnologies] = useState<Array<string>>([]);
  const [filteredPersons, setFilteredPersons] = useState<Array<string>>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const filteredClients = clients
    .sort((a: Client, b: Client) => a.name.localeCompare(b.name))
    .filter((t) => {
      if (filteredTechnologies.length > 0 && !t.technologies?.some((t) => filteredTechnologies.includes(t.id))) {
        return false;
      }
      if (filteredPersons.length > 0 && !t.personRelations?.some((t) => filteredPersons.includes(t.personId))) {
        return false;
      }
      if (searchTerm) {
        return t.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase());
      }
      return true;
    });

  return (
    <Container size={'xl'}>
      <Stack maw={900}>
        <Input
          label="Client name"
          placeholder="Filter by client name"
          value={searchTerm}
          onChange={(value) => setSearchTerm(value.currentTarget.value)}
          required={false}
          maw={400}
        />
        <SimpleGrid
          breakpoints={[
            { minWidth: 'md', cols: 4, spacing: 'md' },
            { minWidth: 'xs', cols: 1, spacing: 'sm' },
          ]}
          style={{ alignItems: 'flex-start' }}
        >
          <MultiSelect
            data={technologies
              .filter((t) => !!t.id)
              .map((t) => {
                return { value: t.id, label: t.name };
              })}
            label={
              <Flex align={'center'}>
                <IconComponents size={16} />
                <Text ml={4}>{'Technologies'}</Text>
              </Flex>
            }
            placeholder="Filter by technologies"
            value={filteredTechnologies}
            onChange={setFilteredTechnologies}
            maw={400}
            searchable
          />
          <MultiSelect
            data={persons.map((t) => {
              return { value: t.id, label: t.name };
            })}
            label={
              <Flex align={'center'}>
                <IconUser size={16} />
                <Text ml={4}>{'Persons'}</Text>
              </Flex>
            }
            placeholder="Filter by persons"
            value={filteredPersons}
            onChange={setFilteredPersons}
            maw={400}
            searchable
          />
        </SimpleGrid>
      </Stack>
      <Space h="md" />
      <Text color="dimmed" size={'sm'}>{`${filteredClients.length} clients`}</Text>
      <Space h="md" />
      <SimpleGrid
        breakpoints={[
          { minWidth: 'md', cols: 3, spacing: 'md' },
          { minWidth: 'sm', cols: 2, spacing: 'sm' },
          { minWidth: 'xs', cols: 1, spacing: 'sm' },
        ]}
      >
        {filteredClients.map((client) => (
          <ClientCard key={client.id} client={client} />
        ))}
      </SimpleGrid>
    </Container>
  );
};

export default ClientList;
